import { CodiItem, Background, Pose } from "../classes";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// initState
const initialState = {
  //generation-setting 정보들
  getInfo: false, //false면 안 받음, true면 받음
  codiItemList: [],
  backgroundList: [],
  poseList: [],
};

// Reducer

interface generationSettingInterface {
  getInfo: boolean;
  codiItemList: CodiItem[];
  backgroundList: Background[];
  poseList: Pose[];
}

export const generationSettingSlice = createSlice({
  name: "generation_setting",
  initialState,
  reducers: {
    setGenerationSetting: (
      state,
      action: PayloadAction<generationSettingInterface>
    ) => {
      // if (action.payload.getInfo) {
      state.getInfo = action.payload.getInfo;
      // }
      // if (action.payload.codiItemList) {
      state.codiItemList = action.payload.codiItemList as never[];
      // }
      // if (action.payload.backgroundList) {
      state.backgroundList = action.payload.backgroundList as never[];
      // }
      // if (action.payload.poseList) {
      state.poseList = action.payload.poseList as never[];
      // }
    },
  },
});

export const { setGenerationSetting } = generationSettingSlice.actions;
export const generationSettingReducer = generationSettingSlice.reducer;
